import useSWR from 'swr';
import { useTranslation } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { Flex } from '@yoweb/ui/components/Flex';
import { Button } from '@yoweb/ui/components/buttons';
import { TextSeperator } from '@poplar/components/TextSeperator';
import { FlyoutTodoLayout } from '@poplar/components/Flyout/FlyoutTodo';
import { API_TASK_TEMPLATE_CATEGORY } from '@poplar/constants/routes';
import { fetcher } from '@yoweb/utils/common';
import { LoadingPage } from '@yoweb/ui/components/LoadingPage';
import { ErrorSubstate } from '@poplar/components/ErrorSubstate';
import { CategoryCard } from '@poplar/components/TaskTemplate/CategoryCard';
import { trackEvent } from '@yoweb/utils/analytics/mixpanel';
import { useUser } from '@poplar/hooks/useUser';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var TopLevelInner = function TopLevelInner(_ref) {
  var onCategoryClicked = _ref.onCategoryClicked;

  var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;

  var _useSWR = useSWR(isAuthenticated ? API_TASK_TEMPLATE_CATEGORY : undefined, fetcher),
      data = _useSWR.data,
      error = _useSWR.error;

  if (error) {
    return /*#__PURE__*/_jsx(ErrorSubstate, {
      error: error
    });
  }

  if (!data) {
    return /*#__PURE__*/_jsx(LoadingPage, {});
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: data.map(function (card) {
      return /*#__PURE__*/_jsx(CategoryCard, {
        card: card,
        onClick: function onClick() {
          onCategoryClicked(card.id);
          trackEvent({
            todoCategoryView: {
              categoryTitle: card.name
            }
          });
        }
      }, card.id);
    })
  });
};

export var TopLevel = function TopLevel(_ref2) {
  var onClose = _ref2.onClose,
      onCreateCustomClicked = _ref2.onCreateCustomClicked,
      onCategoryClicked = _ref2.onCategoryClicked;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(FlyoutTodoLayout, {
    title: t('todo-intake.top-level-title'),
    description: t('todo-intake.description'),
    "data-testid": "top-level-layout",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      display: "grid",
      gap: "small4",
      children: /*#__PURE__*/_jsx(TopLevelInner, {
        onCategoryClicked: onCategoryClicked
      })
    }), /*#__PURE__*/_jsx(Box, {
      mt: "normal3",
      children: /*#__PURE__*/_jsx(TextSeperator, {
        text: t('todo-intake.or-divider')
      })
    }), /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(Box, {
        mt: "normal3",
        children: /*#__PURE__*/_jsx(Button, {
          variant: "secondary",
          size: "lg",
          type: "button",
          onClick: onCreateCustomClicked,
          "data-testid": "create-todo-custom-todo-button",
          children: t('todo-intake.create-type-c')
        })
      })
    })]
  });
};